import { __rest } from 'tslib';
import { useMediaQuery, PeekContainedIconButton, PeekStack, PeekTypography } from '@piiqtechnologies/ui-components';
import React, { forwardRef } from 'react';

const ActionButton = (_a, ref) => {
    var { Icon, selected, children, sx, label, onClick } = _a, props = __rest(_a, ["Icon", "selected", "children", "sx", "label", "onClick"]);
    const mobileView = useMediaQuery((theme) => theme.breakpoints.down("md"));
    const desktopView = useMediaQuery((theme) => theme.breakpoints.up("lg"));
    const handleActionClick = (e) => {
        onClick(e);
    };
    return (React.createElement(PeekContainedIconButton, Object.assign({ ref: ref, sx: Object.assign({ borderRadius: 5, p: { xs: 0, md: 0.8 }, color: "white", bgcolor: "transparent", transition: "color 0.2s ease-in", alignSelf: mobileView ? "center" : null, ":hover": {
                color: "secondary.main",
                backgroundColor: "transparent",
            } }, sx), onClick: handleActionClick, title: label }, props),
        React.createElement(PeekStack, { alignItems: "center", direction: "column" },
            React.createElement(PeekTypography, { lineHeight: "0px", color: (selected && "secondary") || "" },
                React.createElement(Icon, { height: ((desktopView || mobileView) && 32) || 26, width: ((desktopView || mobileView) && 32) || 26 })),
            children,
            label && (React.createElement(PeekTypography, { whiteSpace: "nowrap", variant: !desktopView ? "body1" : "h4", color: (selected && "secondary") || "" }, label)))));
};
const ViewerActionButton = forwardRef(ActionButton);

export { ActionButton, ViewerActionButton, ViewerActionButton as default };
